import { useMutation, useQueryClient } from "@tanstack/react-query";
import { setCheckoutAddress } from "../../services/checkoutApi";
import { useCheckoutStore } from "../../store/checkoutStore";

export const useUpdateAddress = () => {
  const queryClient = useQueryClient();
  const setDestinationAddress = useCheckoutStore(
    (state) => state.setDestinationAddress
  );

  return useMutation({
    mutationFn: async (address) => {
      await setCheckoutAddress(address.id);
      return address;
    },

    onMutate: async (address) => {
      await queryClient.cancelQueries({ queryKey: ["checkout"] });

      const previousCheckout = queryClient.getQueryData(["checkout"]);

      // optimistic update فقط برای آدرس
      queryClient.setQueryData(["checkout"], (oldData) => {
        if (!oldData) return oldData;

        return {
          ...oldData,
          destination_address: address,
        };
      });

      setDestinationAddress(address);

      return { previousCheckout };
    },

    onError: (error, _address, context) => {
      if (context?.previousCheckout) {
        queryClient.setQueryData(["checkout"], context.previousCheckout);
        setDestinationAddress(context.previousCheckout.destination_address || null);
      }

      console.error("خطا در تغییر آدرس تحویل:", error);
    },

    onSuccess: async (address) => {
      setDestinationAddress(address);

      // خیلی مهم: فقط invalidate کافی نیست؛ باید صبر کنیم refetch کامل شود
      await queryClient.invalidateQueries({ queryKey: ["checkout"] });
      await queryClient.refetchQueries({ queryKey: ["checkout"], exact: true });
    },
  });
};
